/* =========================================================
   GIFT OF WATER — Givonate widget controller (optimised)
   ---------------------------------------------------------
   One script for all 4 campaigns. Each campaign = same design
   & functionality, only its position (slot) changes.

   IMPORTANT — for all 4 to work you MUST have 4 Givonate app
   blocks on the page (one per campaign). Givonate widgets
   cannot be reliably cloned, so add the app block 4 times in
   the theme editor. This script then distributes them into the
   4 design slots (hero + 3 cards) and wires each one up.

   SELECTED-AMOUNT LABEL (line under the grid) — supply the 6
   labels ONE of two ways:

     A) Global (same for every campaign) — define BEFORE this file:
        <script>
          window.GOW_LABELS = [
            "Monthly amount 1 text",   // amounts[0]  (Monthly)
            "Monthly amount 2 text",   // amounts[1]  (Monthly)
            "Monthly amount 3 text",   // amounts[2]  (Monthly)
            "One-time amount 1 text",  // amounts[3]  (Now)
            "One-time amount 2 text",  // amounts[4]  (Now)
            "One-time amount 3 text"   // amounts[5]  (Now)
          ];
        </script>

     B) Per campaign — JSON array on the slot:
        <div class="gow-appslot" data-gow-labels='["m1","m2","m3","n1","n2","n3"]'></div>

   CUSTOM AMOUNT:
   The native .Givonate-Widget-input is hidden and replaced with a
   styled .custom-amount-input. Typing pushes the value into the
   native input (so Givonate registers it). A REAL user tap on a
   preset (event.isTrusted) clears the custom field; synthetic /
   programmatic clicks are ignored.

   --- OPTIMISATION NOTES (vs previous build) ---------------
   * One-time DOM surgery (footer / remove-text / custom amount /
     hide-native) now runs ONCE per slot (slot._gowSetupDone).
   * applyMode() no longer schedules timers. The async-render
     retry burst runs ONCE per toggle build / user toggle.
   * Watchers self-terminate: the polling interval AND the
     MutationObserver disconnect once all slots are wired and
     stable, and unconditionally after a hard cap. Nothing
     observes the DOM for the life of the page.
   ========================================================= */
(function () {
  'use strict';

  var CONFIG = {
    monthlyCount: 3,           // first N amounts = Monthly, the rest = Now
    defaultMode: 'now',        // per-slot override: data-gow-mode="monthly"
    clickDebounceMs: 600,
    heroSlot:  '.gow-hero .gow-hero__widget .gow-appslot',
    cardSlots: '.gow-section--page .gow-card .gow-appslot',

    // custom footer (replaces .Givonate-Widget-footer)
    programText: 'Donate Directly',
    payIconsUrl: 'https://cdn.shopify.com/s/files/1/0907/3927/8131/files/payicons.png?v=1781600024',

    // any leaf element whose text exactly matches one of these is removed
    removeTexts: ['How much would you like to donate today?'],

    // custom amount field
    customAmountPlaceholder: '£ Enter Amount Here',

    // watcher lifecycle
    pollMs: 1000,              // re-scan cadence while settling
    pollMaxAttempts: 40,       // hard stop for the polling interval
    settleMs: 5000,            // stay-ready this long -> disconnect watchers
    hardCapMs: 60000,          // disconnect watchers no matter what

    debug: true                // set false to silence console diagnostics
  };

  document.documentElement.classList.add('gow-js');

  /* ---------- module-scoped watcher handles ---------- */
  var pollTimer  = null;
  var observer   = null;
  var settleTimer = null;
  var capTimer   = null;
  var pollAttempts = 0;

  function isGivonate(el) {
    return !!el.querySelector('[id^="Givonate-Widget"], .Givonate-Widget, .GivonateButton');
  }

  /* ---------- 1) relocate the widgets into the slots ---------- */
  function moveWidgets() {
    var widgets = Array.prototype.slice
      .call(document.querySelectorAll('.shopify-app-block'))
      .filter(isGivonate);
    if (!widgets.length) return;

    var cardSlots = document.querySelectorAll(CONFIG.cardSlots);
    var slots = [
      document.querySelector(CONFIG.heroSlot),
      cardSlots[0], cardSlots[1], cardSlots[2]
    ];

    for (var i = 0; i < slots.length; i++) {
      var slot = slots[i], w = widgets[i];
      if (!slot || !w || slot.contains(w)) continue;
      var notes = slot.querySelectorAll('.gow-appslot__note');
      for (var n = 0; n < notes.length; n++) notes[n].remove();
      slot.appendChild(w);
    }
  }

  /* ---------- 2) helpers (scoped to one slot) ---------- */
  function amounts(slot) {
    return slot.querySelectorAll('.Givonate-Widget-grid .Givonate-Widget-amount');
  }

  function setToggleActive(toggle, mode) {
    var btns = toggle.querySelectorAll('.gow-toggle__btn');
    for (var i = 0; i < btns.length; i++) {
      btns[i].classList.toggle('is-active', btns[i].getAttribute('data-mode') === mode);
    }
  }

  function hideNative(slot) {
    var header = slot.querySelector('.Givonate-Widget-header');
    if (header) header.style.display = 'none';
    var img = slot.querySelector('.Givonate-Widget > div > img');
    if (img && img.parentElement) img.parentElement.style.display = 'none';
    var label = slot.querySelector('.Givonate-Checkbox-label');
    if (label) label.classList.add('gow-hidden-check');
  }

  // Replace Givonate's native footer with our own "customer-footer".
  function buildCustomFooter(slot) {
    var widget = slot.querySelector('.Givonate-Widget');
    if (!widget) return;

    var native = widget.querySelector('.Givonate-Widget-footer');
    if (native) native.remove();

    if (widget.querySelector('.customer-footer')) return; // build once

    var footer = document.createElement('div');
    footer.className = 'customer-footer';

    var text = document.createElement('div');
    text.className = 'customer-footer__text';
    text.textContent = CONFIG.programText;
    footer.appendChild(text);

    var url = CONFIG.payIconsUrl;
    if (url && url.indexOf('REPLACE_WITH') === -1) {
      var img = document.createElement('img');
      img.className = 'customer-footer__icons';
      img.src = url;
      img.alt = 'Accepted payment methods';
      img.loading = 'lazy';
      footer.appendChild(img);
    }

    widget.appendChild(footer);
  }

  // Remove leaf elements whose text exactly matches CONFIG.removeTexts.
  function removeByText(slot) {
    var wanted = CONFIG.removeTexts;
    if (!wanted || !wanted.length) return;
    var els = slot.querySelectorAll('p, h1, h2, h3, h4, h5, span, div, label');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.children.length) continue;            // only leaf nodes
      if (wanted.indexOf(el.textContent.trim()) !== -1) el.remove();
    }
  }

  /* ---------- custom amount field ---------- */
  function nativeAmountInput(slot) {
    var w = slot.querySelector('.Givonate-Widget-input');
    return w ? w.querySelector('input') : null;
  }

  function setNativeAmount(slot, val) {
    var inp = nativeAmountInput(slot);
    if (!inp) return;
    inp.value = val;
    inp.dispatchEvent(new Event('input',  { bubbles: true }));
    inp.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function ensureCustomAmount(slot) {
    var wrap = slot.querySelector('.Givonate-Widget-input');
    if (!wrap) return;
    wrap.style.display = 'none';                 // hide native input

    if (slot.querySelector('.custom-amount-input')) return; // build once

    var box = document.createElement('div');
    box.className = 'custom-amount-wrapper';

    var input = document.createElement('input');
    input.type = 'number';
    input.min = '1';
    input.step = '0.01';
    input.className = 'custom-amount-input';
    input.placeholder = CONFIG.customAmountPlaceholder;

    box.appendChild(input);
    wrap.insertAdjacentElement('afterend', box);
  }

  // labels for THIS slot: per-slot JSON wins, else the global array
  function getLabels(slot) {
    var raw = slot.getAttribute('data-gow-labels');
    if (raw) { try { return JSON.parse(raw); } catch (e) {} }
    return window.GOW_LABELS || [];
  }

  // show the selected amount's text under the grid
  function renderNote(slot) {
    var grid = slot.querySelector('.Givonate-Widget-grid');
    if (!grid) return;

    var labels = getLabels(slot);
    var amts   = amounts(slot);
    var active = slot.querySelector('.Givonate-Widget-amount-active');
    var idx    = active ? Array.prototype.indexOf.call(amts, active) : -1;
    var text   = (idx > -1 && labels[idx]) ? labels[idx] : '';

    var note = grid.parentNode.querySelector('.gow-amount-note');
    if (!text) { if (note) note.textContent = ''; return; }
    if (!note) {
      note = document.createElement('div');
      note.className = 'gow-amount-note';
      grid.insertAdjacentElement('afterend', note);
    }
    if (note.textContent !== text) note.textContent = text;   // skip redundant writes
  }

  // show first N for Monthly, last N for Now; keep a visible amount selected
  function applyAmounts(slot, mode) {
    var amts = amounts(slot);
    if (amts.length < CONFIG.monthlyCount * 2) return;

    var n = CONFIG.monthlyCount;
    for (var i = 0; i < amts.length; i++) {
      var isMonthlyAmount = i < n;
      var show = (mode === 'monthly') ? isMonthlyAmount : !isMonthlyAmount;
      amts[i].style.display = show ? '' : 'none';
    }

    // While a custom amount is being typed, do NOT auto-pick a preset.
    if (slot._gowCustomActive) return;

    var active = slot.querySelector('.Givonate-Widget-amount-active');
    if (!active || active.style.display === 'none') {
      for (var j = 0; j < amts.length; j++) {
        if (amts[j].style.display !== 'none') { amts[j].click(); break; }
      }
    }
  }

  function syncRecurring(slot, checkbox, mode) {
    var wantMonthly = (mode === 'monthly');
    var now = Date.now();
    if (checkbox.checked !== wantMonthly &&
        now - (slot._gowClickTs || 0) > CONFIG.clickDebounceMs) {
      slot._gowClickTs = now;
      checkbox.click();
    }
  }

  // Cheap per-tick application (no timers scheduled here).
  function applyMode(slot, checkbox, mode) {
    applyAmounts(slot, mode);
    syncRecurring(slot, checkbox, mode);
    renderNote(slot);
  }

  // Givonate renders amounts asynchronously; re-apply a few times AFTER a
  // toggle is (re)built or the user switches mode. Runs once per trigger.
  function settleBurst(slot, checkbox) {
    [50, 150, 300].forEach(function (ms) {
      setTimeout(function () {
        if (!document.contains(slot)) return;     // slot gone -> skip
        var m = slot.getAttribute('data-gow-mode') || CONFIG.defaultMode;
        applyAmounts(slot, m);
        renderNote(slot);
      }, ms);
    });
  }

  /* ---------- 3) enhance a single slot ---------- */
  function enhanceSlot(slot) {
    var amountsBox = slot.querySelector('.Givonate-Widget-amounts');
    var checkbox   = slot.querySelector('.Givonate-Checkbox-input');
    if (!amountsBox || !checkbox) return;          // widget not rendered yet

    // One-time DOM surgery.
    if (!slot._gowSetupDone) {
      buildCustomFooter(slot);
      removeByText(slot);
      ensureCustomAmount(slot);
      hideNative(slot);
      slot._gowSetupDone = true;
    }

    var mode = slot.getAttribute('data-gow-mode') || CONFIG.defaultMode;
    var toggle = amountsBox.querySelector('.gow-toggle');

    // Build the toggle once (self-heals if Givonate ever wipes it).
    if (!toggle) {
      toggle = document.createElement('div');
      toggle.className = 'gow-toggle';
      toggle.innerHTML =
        '<button type="button" class="gow-toggle__btn" data-mode="monthly">Monthly</button>' +
        '<button type="button" class="gow-toggle__btn" data-mode="now">Now</button>';
      amountsBox.insertBefore(toggle, amountsBox.firstChild);

      toggle.addEventListener('click', function (e) {
        var b = e.target.closest('.gow-toggle__btn');
        if (!b) return;
        var m = b.getAttribute('data-mode');
        slot.setAttribute('data-gow-mode', m);
        applyMode(slot, checkbox, m);
        setToggleActive(toggle, m);
        settleBurst(slot, checkbox);
      });

      settleBurst(slot, checkbox);                 // initial async catch-up
    }

    // Cheap each pass: keeps amount filtering correct as Givonate renders.
    applyMode(slot, checkbox, mode);
    setToggleActive(toggle, mode);
  }

  function enhanceAll() {
    var slots = document.querySelectorAll('.gow-appslot');
    for (var i = 0; i < slots.length; i++) enhanceSlot(slots[i]);
  }

  // Delegated handlers (added once): notes + custom amount.
  function bindAmountDelegation() {
    if (window._gowAmountDelegation) return;
    window._gowAmountDelegation = true;

    // preset clicked -> update note. Only a REAL user tap (isTrusted)
    // empties the custom field; programmatic clicks are ignored.
    document.addEventListener('click', function (e) {
      var amt = e.target.closest && e.target.closest('.Givonate-Widget-amount');
      if (!amt) return;
      var slot = amt.closest('.gow-appslot');
      if (!slot) return;
      if (e.isTrusted) {
        var ci = slot.querySelector('.custom-amount-input');
        if (ci) ci.value = '';
        slot._gowCustomActive = false;
      }
      setTimeout(function () { renderNote(slot); }, 30);
      setTimeout(function () { renderNote(slot); }, 120);
    }, true);

    // typing in custom field -> push value into Givonate's native input
    document.addEventListener('input', function (e) {
      var inp = e.target;
      if (!inp.classList || !inp.classList.contains('custom-amount-input')) return;
      var slot = inp.closest('.gow-appslot');
      if (!slot) return;
      var v = parseFloat(inp.value);
      if (isNaN(v) || v < 1) {
        slot._gowCustomActive = false;
        setNativeAmount(slot, '');
        return;
      }
      slot._gowCustomActive = true;
      setNativeAmount(slot, v);
    }, true);
  }

  /* ---------- 4) run + self-heal + auto-teardown ---------- */
  function diagnose() {
    if (!CONFIG.debug) return;
    var blocks = Array.prototype.slice
      .call(document.querySelectorAll('.shopify-app-block')).filter(isGivonate).length;
    var slots = document.querySelectorAll('.gow-appslot');
    var filled = 0;
    for (var i = 0; i < slots.length; i++) {
      if (slots[i].querySelector('.Givonate-Widget-amounts')) filled++;
    }
    console.log('[GOW] Givonate blocks:', blocks,
                '| .gow-appslot slots:', slots.length,
                '| slots with a live widget:', filled);
    if (blocks < slots.length) {
      console.warn('[GOW] Fewer Givonate blocks than slots. Add the Givonate app ' +
                   'block once per campaign — that is why only the first toggle works.');
    }
  }

  // Every existing slot has a toggle wired => fully settled.
  function allSlotsReady() {
    var slots = document.querySelectorAll('.gow-appslot');
    if (!slots.length) return false;
    for (var i = 0; i < slots.length; i++) {
      if (!slots[i].querySelector('.gow-toggle')) return false;
    }
    return true;
  }

  function teardownWatchers() {
    if (pollTimer)   { clearInterval(pollTimer); pollTimer = null; }
    if (observer)    { observer.disconnect();    observer = null; }
    if (settleTimer) { clearTimeout(settleTimer); settleTimer = null; }
    if (capTimer)    { clearTimeout(capTimer);    capTimer = null; }
    if (CONFIG.debug) console.log('[GOW] watchers torn down (settled).');
  }

  // Once everything is wired and stays wired for settleMs, stop watching.
  function maybeSettle() {
    if (allSlotsReady()) {
      if (!settleTimer) settleTimer = setTimeout(teardownWatchers, CONFIG.settleMs);
    } else if (settleTimer) {
      clearTimeout(settleTimer);
      settleTimer = null;
    }
  }

  function tick() {
    moveWidgets();
    enhanceAll();
    maybeSettle();
  }

  function start() {
    bindAmountDelegation();
    tick();
    diagnose();

    // Bounded polling for late-rendering widgets.
    pollTimer = setInterval(function () {
      tick();
      if (++pollAttempts > CONFIG.pollMaxAttempts) {
        if (pollTimer) { clearInterval(pollTimer); pollTimer = null; }
        diagnose();
      }
    }, CONFIG.pollMs);

    // Self-heal during the volatile load phase only.
    if (window.MutationObserver) {
      var t;
      observer = new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(tick, 150);
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }

    // Absolute guarantee that nothing observes forever.
    capTimer = setTimeout(teardownWatchers, CONFIG.hardCapMs);
  }

  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', start);
  else
    start();
})();



document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.gow-tier-card__form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var btn = form.querySelector('[data-gow-tier-submit]');
      if (!btn || btn.disabled) return;

      e.preventDefault();
      var textEl = btn.querySelector('.gow-tier-card__btn-text');
      var originalText = textEl ? textEl.textContent : '';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: form.querySelector('[name="id"]').value,
          quantity: 1
        })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function () {
          if (textEl) textEl.textContent = 'ADDED ✓';
          btn.classList.add('is-added');
          document.dispatchEvent(new CustomEvent('cart:updated'));
          setTimeout(function () {
            btn.classList.remove('is-added');
            if (textEl) textEl.textContent = originalText;
            btn.disabled = false;
          }, 1800);
                    window.location.href = '/checkout';

        })
        .catch(function () {
          btn.disabled = false;
          form.submit();
        });
    });
  });
});